import { Colors, Icon } from "@blueprintjs/core";
import { Link } from "react-router";

import { getUpsellParams } from "@/components/helpers/upsell/get-upsell-params";
import { Box, Flex } from "@/components/layout/flexbox";
import { FlexibleButton } from "@/components/pieces/button/FlexibleButton";

interface UpgradeToProProps {
  benefits?: string[];
  customMessage?: string;
  ctaType: string;
  ctaSource: string;
}

export function UpgradeToPro({
  benefits = [],
  customMessage,
  ctaType,
  ctaSource,
}: UpgradeToProProps) {
  return (
    <Box p={24}>
      {customMessage || (
        <>
          <Box mb={3} fontSize={20} fontWeight={600}>
            Work With a Coach
          </Box>

          <Box my={3}>
            {benefits.map((benefit) => {
              return (
                <Flex key={benefit} alignItems="top" mt={12}>
                  <Box>
                    <Icon icon="small-tick" color={Colors.FOREST4} size={25} />
                  </Box>
                  <Box pl={2} width="90%">
                    {benefit}
                  </Box>
                </Flex>
              );
            })}
          </Box>
        </>
      )}

      <Box mt={24}>
        <FlexibleButton
          as={Link}
          to={`/match?${getUpsellParams(ctaType, ctaSource)}`}
          variant="primary"
          size="large"
        >
          Find My Coach
        </FlexibleButton>
      </Box>
    </Box>
  );
}
